import { isClient } from './base';

/*
 * @Description:
 * @Version: 1.0
 * @Author: wangmingxu@kuaishou.com
 * @Date: 2022-06-02 18:47:24
 * @LastEditors: wangmingxu@kuaishou.com
 * @LastEditTime: 2022-09-09 10:40:57
 */
function genPropType(type) {
  return type;
}
function genType(t) {
  return function () {
    var type = genPropType(t);
    return {
      type: type,
      re: function re() {
        return {
          type: type,
          required: true
        };
      },
      def: function def(val) {
        return {
          type: type,
          "default": t === Object || t === Array ? function () {
            return val;
          } : val
        };
      }
    };
  };
}
function oneOfType(props) {
  var types = props.map(function (_ref) {
    var type = _ref.type;
    return type;
  });
  return genType(types)();
}
var propTypes = {
  dom: genType(isClient ? HTMLElement : Object),
  number: genType(Number),
  string: genType(String),
  "boolean": genType(Boolean),
  "function": genType(Function),
  symbol: genType(Symbol),
  array: genType(Array),
  date: genType(Date),
  object: genType(Object),
  "null": genType(null),
  oneOfType: oneOfType
};

export { propTypes as default };
